import { createRoot, type Root } from "react-dom/client";
import Beliefs from "../pages/Beliefs/Beliefs";
import "../index.css";
import "../pages/Beliefs/Beliefs.recovered.css";
import "../pages/Beliefs/Beliefs.custom.css";

let root: Root | null = null;

function mount(element: HTMLElement) {
  if (root) return;

  root = createRoot(element);
  root.render(<Beliefs />);
}

function unmount() {
  root?.unmount();
  root = null;
}

window.ACADBeliefs = { mount, unmount };

function boot() {
  const element = document.getElementById("beliefs-root");
  if (element) mount(element);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}
